import * as React from 'react';
import { CircularProgress } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useConsentStyles } from './styles';

// The spinner is hidden from assistive technology (an unnamed progressbar);
// the visible "Sending…" text is the accessible state.
export default function SendingLabel() {
  const { t } = useTranslation();
  const classes = useConsentStyles();

  return (
    <>
      <CircularProgress size={16} color="inherit" aria-hidden="true" className={classes.spinner} />
      {t('mcp.consent.sending')}
    </>
  );
}
